/*
 * `gql` comes from @codecraftkit/apollo-adapter, NOT from 'graphql-tag'.
 *
 * Apollo Client 4 moved its React bindings out of the package root, which broke the BUILD of a
 * whole app with an error pointing at node_modules — where nobody can fix it. The adapter makes
 * the next such move one file in the monorepo instead of one import site per package.
 */
import { gql } from '@codecraftkit/apollo-adapter'

export const S_IMAGE_GROUP_BY_CATEGORIES = gql`
    query S_ImageGroup_groupByCategory($key:String, $agencyId:String) {
      S_ImageGroup_groupByCategory(key:$key, agencyId: $agencyId) {
            _id
            name
            key
            description
            images {
                category
                items{
                    fileName
                    fileType
                    originalName
                    size
                    url
                    ETag
                    agencyId
                }
            }
        }
    }
`;
